export default "__VITE_ASSET__Dm0HaM5l__"